import { useState, useEffect } from "react";
import { RadioInput } from "../../../../lib/inputs";
import { Sexes } from "../../../../config/RaceConfigs";
import { RegistrationFieldLabels } from "../../../../config/RegistrationConfigs";
import useForm from "../../../../lib/common/AsyncFormBox/useForm";

/**
 * SexInput - Radio input for selecting sex
 *
 * @param {Object} props
 * @param {string} [props.value] - Controlled sex value
 * @param {string} [props.defaultValue] - Default sex value (uncontrolled mode)
 * @param {Function} [props.onChange] - Callback when sex changes, receives new sex value
 */
export default function SexInput({ value, defaultValue = "", onChange, disabled = false }) {
  const form = useForm();
  const isControlled = value !== undefined;
  const [sex, setSex] = useState(defaultValue);

  useEffect(() => {
    if (isControlled) {
      setSex(value || "");
      if (value) {
        form.setValue("sex", value);
      }
    } else if (defaultValue) {
      setSex(defaultValue);
      form.setValue("sex", defaultValue);
    }
  }, [value, defaultValue, isControlled, form]);

  function handleChange(newSex) {
    setSex(newSex);
    form.setValue("sex", newSex);
    onChange && onChange(newSex);
  }

  return (
    <RadioInput
      name="sex"
      label={RegistrationFieldLabels.sex}
      radioList={Object.keys(Sexes).map((key) => ({
        value: key,
        label: Sexes[key].name,
      }))}
      defaultValue={isControlled ? value : sex}
      onChange={handleChange}
      required
      fullWidth
      row
      size="small"
      disabled={disabled}
    />
  );
}
